module.exports = __webpack_public_path__ + "static/media/CHAP01-ARTIC-LOGO.21dabb70.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Element/img/CHAP01-ARTIC-LOGO.png
// module id = 248
// module chunks = 0